(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("necom", [], factory);
	else if(typeof exports === 'object')
		exports["necom"] = factory();
	else
		root["necom"] = factory();
})(self, () => {
return 